import React from 'react';

import { LightBoxImage } from './image/LightBoxImage';
import ImageBlueSheet from './../images/blue_sheet.png';
import ImageGreenSheet from './../images/green_sheet.png';
import ImageDbToPc from './../images/db_to_pc.png';
import ImageNoTransferPdf from './../images/no_transfer_pdf.png';
import ImagePcToDb from './../images/pc_to_db.png';
import ImagePdfXlsCsv from './../images/pdf_xls_csv.png';
import ImageTable from './../images/table.png';
import ImageXO from './../images/x_o.png';
import PrintUtility from '../utilities/printUtility';
import { FILE_CODE } from '../utilities/constants';
import { WorkerRegistrationApplicationService } from './../services/WorkerRegistrationApplication';
import '../styles/organisms/worker-registration-application-instructions.scss';

export const WorkerRegistrationApplicationInstructions = () => {
  return (
    <div className='WorkerRegistrationApplicationInstructions'>
      <div className='WorkerRegistrationApplicationInstructions__panel'>
        <InstructionPanel title='登録可能な作業員名簿データ'>
          <ListWorkersRegister />
        </InstructionPanel>
        <InstructionPanel title='ダウンロードから登録までの流れ'>
          <StreamDownloadToRegister />
        </InstructionPanel>
      </div>

      <div className='WorkerRegistrationApplicationInstructions__panel'>
        <InstructionPanel title='代行登録できない作業員名簿データ'>
          <DataRegister />
        </InstructionPanel>
        <InstructionPanel title='注意事項'>
          <Notes />
        </InstructionPanel>
      </div>
    </div>
  );
};

const InstructionPanel = ({ title, children, ...rest }) => {
  return (
    <div className='panel-content' {...rest}>
      <div className='panel-content__title'>{title}</div>
      <div className='panel-content__body'>{children}</div>
    </div>
  );
};

const ListWorkersRegister = () => {
  const pdfDownLoadByFileCode = async (fileName, file_code) => {
    await PrintUtility.printOrOpenBlob(
      async () => {
        const response = await WorkerRegistrationApplicationService.downloadByFileCode(
          {
            file_code,
          }
        );
        return new Blob([response], { type: 'application/pdf' });
      },
      `${fileName}.pdf`,
      FILE_CODE.PDF,
      false
    );
  };

  return (
    <div className='panel-content__body-data panel-content__body-data--high'>
      <div className='body-data body-data--text-center'>
        <div className='body-data__image--space-top'>
          <LightBoxImage imageUrl={ImageBlueSheet} disabled={true} />
        </div>
        <p className='body-data__description'>
          対応帳票：「標準様式第5号」の最新版
        </p>
        <p>
          <a
            className='clickable-text'
            onClick={() =>
              pdfDownLoadByFileCode(
                '作業員名簿データの出力方法（グリーンサイト）',
                'greensiteDataExportManual'
              )
            }
          >
            ※作業員名簿データの出力方法（ダウンロード方法）はこちら
          </a>
        </p>
      </div>
      <div className='body-data body-data--text-center'>
        <div className='body-data__image--space-top'>
          <LightBoxImage imageUrl={ImageGreenSheet} disabled={true} />
        </div>
        <p className='body-data__description'>
          対応帳票：「標準様式第5号」の最新版
        </p>
        <p>
          <a
            className='clickable-text'
            onClick={() =>
              pdfDownLoadByFileCode(
                '作業員名簿データの出力方法（Greenfile.work）',
                'greenfileworkDataExportManual'
              )
            }
          >
            ※作業員名簿データの出力方法（ダウンロード方法）はこちら
          </a>
        </p>
      </div>
    </div>
  );
};

const StreamDownloadToRegister = () => {
  return (
    <div className='panel-content__body-data panel-content__body-data--high'>
      <div className='body-data body-data--outline'>
        <p className='body-data__step'>
          ①他システムから作業員名簿データ（PDF）をパソコンなどの端末にダウンロード
        </p>
        <div className='body-data__image'>
          <img src={ImageDbToPc} />
        </div>
      </div>
      <div className='body-data body-data--outline'>
        <p className='body-data__step'>
          ②ダウンロードした作業員名簿データ（PDF）をそのままの状態でBuildeeへアップロード
        </p>
        <div className='body-data__image'>
          <img src={ImagePcToDb} />
        </div>
        <p>
          <a className='body-data__text--warning'>
            ※データは開かずにそのままアップロードいただくようお願いします。
          </a>
        </p>
      </div>
    </div>
  );
};

const DataRegister = () => {
  return (
    <React.Fragment>
      <div className='panel-content__body-data panel-content__body-data--low'>
        <div className='body-data body-data--outline'>
          <p className='body-data__step'>①PDF形式以外のデータ</p>
          <p className='body-data__step__info'>
            Excel・CSVなどのデータでは申請できません。
          </p>
          <div className='body-data__image'>
            <img src={ImagePdfXlsCsv} />
          </div>
        </div>
        <div className='body-data body-data--outline'>
          <p className='body-data__step'>②紙をスキャンしたデータ</p>
          <p className='body-data__step__info'>
            紙をスキャンしたPDFデータでは申請できません。
          </p>
          <div className='body-data__image'>
            <img src={ImageNoTransferPdf} />
          </div>
        </div>
      </div>
      <div className='panel-content__body-data panel-content__body-data--low'>
        <div className='body-data body-data--no-title body-data--outline'>
          <p className='body-data__step'>③2社以外の作業員名簿データ</p>
          <p>
            「グリーンサイト」「Greenfile.work」以外のデータでは申請できません。
          </p>
          <div className='body-data__image'>
            <img src={ImageXO} />
          </div>
        </div>
        <div className='body-data body-data--no-title body-data--outline'>
          <p className='body-data__step'>
            ④基本項目【姓名／セイメイ／性別／生年月日】がない作業員が含まれるデータ
          </p>
          <p className='body-data__step--info'>
            基本項目のいづれか1つでもないデータがあると申請できません
          </p>
          <div className='body-data__image'>
            <img src={ImageTable} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const Notes = () => {
  return (
    <ul className='WorkerRegistrationApplicationInstructions__notes'>
      <li className='notes__line'>
        Buildee上では〈個人〉として登録されている法人の協力会社からの申請は対応できません。
        <br />
        Buildee上に〈法人〉として登録されている協力会社から申請してください。
        <br />
        （画面左の黒メニュー「会社情報」から「基本情報」画面を表示していただき、「会社名ふりがな」の下に「法人格」という項目が表示されていればBuildee上に〈法人〉として登録されています）
      </li>
      <br />
      <li className='notes__line'>
        当社の作業員代行登録は機械的な処理により行います。
        <br />
        PDF編集ソフトなどでデータを編集している場合は処理できませんので、他システムから出力した作業員名簿データは開かずにそのままアップロードいただくようお願いします。
      </li>
      <br />
      <li className='notes__line'>
        教育・資格・免許関連の情報は、当社の判断にもとづき適宜Buildeeの項目に置き換えて登録を行います。
      </li>
      <li className='notes__line'>
        複数の教育・資格・免許関連の情報をお持ちの作業員については、すべての情報を登録できないことがあります。その場合はご自身で追加登録を行ってください。
      </li>
      <li className='notes__line'>
        基本項目（姓名、セイメイ、性別、生年月日）が一致する作業員がすでにBuildeeに登録されている場合は、登録できません。
      </li>
      <br />
      <li className='notes__line'>
        当社の作業員代行登録が完了したら登録完了メールをお送りします。
      </li>
      <li className='notes__line--notice'>
        当社の作業員代行登録は機械的な処理により行いますが、その登録結果の正しさを保証するものではありません。
        <br />
        そのため登録完了メールが届いたら必ず登録された作業員の情報を確認していただき、誤りがあった場合はご自身で修正を行ってください。当社にて修正依頼をお受けすることはできません。
      </li>
    </ul>
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkerRegistrationApplicationInstructions.jsx